module.exports = __webpack_public_path__ + "img/picnic-banner.f4bdb0a1.jpeg";